import type { Theme } from "theme-ui";

export const borders: Theme["borders"] = {
  primary: {
    border: (theme: Theme) => `2px solid ${theme.colors?.primary}`,
  },
};
